import { SatismeterService } from './satismeter.service';

export default angular
  .module('sfMobile.services.satismeter', [])
  .service('satismeterService', SatismeterService).name;
